module.exports = __webpack_public_path__ + "static/media/38.b9f6bb64.png";